export const AW_DEEPLINK_AUTOMATION_NAME_PARAM: string = 'aw_automation_name';
export const AW_DEEPLINK_WORKFLOW_SOURCE_PARAM: string = 'aw_workflow_source';
export const AW_DEEPLINK_INTENT_TYPE_PARAM: string = 'aw_intent_type';

// Selected signal to open in constructor (e.g., 'ICP', 'PREDICTIVE_INTENT')
export const AW_SELECTED_SIGNAL_PARAM: string = 'aw_sig';
// Prefill saved search id for ICP signal
export const AW_SELECTED_SAVED_SEARCH_PARAM: string = 'aw_saved_search_id';
// Start directly in constructor mode when deep-linking
export const AW_START_CONSTRUCTOR_PARAM: string = 'aw_constructor';


